import React from 'react'
import SEO from '../../seo/SEO' 
import ContactUsBanner from './ContactUsBanner/ContactUsBanner'
import Second_ContactUs from './Second_ContactUs/Second_ContactUs'
import Third_ContactUs from './Third_ContactUs/Third_ContactUs'

const ContactUs = () => {
  return (
        <>
      <SEO />
    <div>
        <ContactUsBanner/>
        <Second_ContactUs/>
        <Third_ContactUs/>
    </div>
    </>
  )
}

export default ContactUs

